// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { AbstractTableFilter, AbstractTableFilterSchema } from 'api/gen/AbstractTableFilter';

const requiredPart = t.interface({
  tag: t.literal('OPTIONAL_BOOLEAN'),
  field: t.string,
  value: t.union([t.boolean, t.null]),
});

export const OptionalBooleanFilterSchema = excess(t.intersection([AbstractTableFilterSchema.type, requiredPart]));

export interface OptionalBooleanFilter extends t.TypeOf<typeof OptionalBooleanFilterSchema> {}
